import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-wrapper" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-[20px] leading-lg font-bold" }
const _hoisted_4 = { class: "text-base" }

import { inject, onMounted, provide, ref } from 'vue';
import boostsiteAiMenuFix from './admin-menu-fix';
import Notifications from './components/layout/Notifications.vue';
import { AppConfigType } from './types';
import useGetUsedTokens from './composables/useGetUsedTokens';
import Popup from './components/layout/Popup.vue';
import { useRouter } from 'vue-router';

// Get plugin config

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const config: AppConfigType = inject('pluginConfig');

// Popup control
const upgradePopup = ref<InstanceType<typeof Popup>>();

// Router
const router = useRouter();

// Provide the account type and expiration globally
const isAccountFree = config.settings.account_type === 'FREE';
const isAccountExpired = !!config.settings.account_expired;
provide('isAccountFree', isAccountFree);
provide('isAccountExpired', isAccountExpired);

// Recaulculate the tokens
useGetUsedTokens();

// Apply the menu fix on mounted
onMounted(() => {
    // @ts-ignore
    boostsiteAiMenuFix(inject('pluginConfig', {}).prefix || 'vue-app');

    if (isAccountExpired && router.currentRoute.value.path !== '/upgrade') {
        upgradePopup.value.openPopup();
    }
});

const popupClick = () => {
    router.push('/upgrade');
    upgradePopup.value.closePopup();
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Notifications),
    _createVNode(_component_router_view),
    isAccountExpired
      ? (_openBlock(), _createBlock(Popup, {
          key: 0,
          ref_key: "upgradePopup",
          ref: upgradePopup,
          "confirm-button-text": _ctx.$gettext('Upgrade'),
          onPopupConfirm: popupClick,
          "is-open": isAccountExpired
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$gettext('Your account has expired')), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$gettext('To continue using the plugin please upgrade your subscription')), 1)
            ])
          ]),
          _: 1
        }, 8, ["confirm-button-text"]))
      : _createCommentVNode("", true)
  ]))
}
}

})